module.exports = __webpack_public_path__ + "media/images/symbols/facebook-social-d8bbd793dff80f2d3d5cb01f48493769.svg";